export default `
/*
  Warnings:

  - You are about to drop the column \`is_public\` on the \`File\` table. All the data in the column will be lost.

*/
-- RedefineTables
PRAGMA defer_foreign_keys=ON;
PRAGMA foreign_keys=OFF;
CREATE TABLE "new_File" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "name" TEXT NOT NULL,
    "relative_path" TEXT NOT NULL,
    "mime_type" TEXT NOT NULL,
    "size" INTEGER NOT NULL,
    "earliest_known_modified_at" DATETIME,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "deleted_at" DATETIME,
    "versioning_mode" TEXT NOT NULL DEFAULT 'ATTACH',
    "auto_version" BOOLEAN NOT NULL DEFAULT false,
    CONSTRAINT "File_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE,
    CONSTRAINT "File_created_by_fkey" FOREIGN KEY ("created_by") REFERENCES "User" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);
INSERT INTO "new_File" ("auto_version", "created_at", "created_by", "deleted_at", "earliest_known_modified_at", "id", "mime_type", "name", "relative_path", "size", "updated_at", "versioning_mode", "workspace_id") SELECT "auto_version", "created_at", "created_by", "deleted_at", "earliest_known_modified_at", "id", "mime_type", "name", "relative_path", "size", "updated_at", "versioning_mode", "workspace_id" FROM "File";
DROP TABLE "File";
ALTER TABLE "new_File" RENAME TO "File";
CREATE INDEX "File_mime_type_idx" ON "File"("mime_type");
CREATE INDEX "File_earliest_known_modified_at_idx" ON "File"("earliest_known_modified_at");
CREATE INDEX "File_workspace_id_idx" ON "File"("workspace_id");
CREATE INDEX "File_created_by_idx" ON "File"("created_by");
CREATE INDEX "File_created_at_idx" ON "File"("created_at");
CREATE INDEX "File_updated_at_idx" ON "File"("updated_at");
PRAGMA foreign_keys=ON;
PRAGMA defer_foreign_keys=OFF;
`;
